const dateTime = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'short',
  day: 'numeric',
  month: 'long',
  hour: '2-digit',
  minute: '2-digit',
});
const dateOnly = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
});
const time = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });

export function formatDateTime(iso: string): string {
  return dateTime.format(new Date(iso));
}

/** Créneau lisible : « jeudi 16 octobre, 14:00 – 15:00 », ou « Sans créneau ». */
export function formatSlot(start: string | null, end: string | null): string {
  if (!start) return 'Sans créneau';
  const startDate = new Date(start);
  const label = `${dateOnly.format(startDate)}, ${time.format(startDate)}`;
  return end ? `${label} – ${time.format(new Date(end))}` : label;
}

const pad = (value: number) => String(value).padStart(2, '0');

/** Valeur pour <input type="datetime-local"> dans le fuseau du navigateur. */
export function toLocalDateTimeInput(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getFullYear())}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function toLocalDateInput(iso: string | null): string {
  return toLocalDateTimeInput(iso).slice(0, 10);
}

export function toLocalTimeInput(iso: string | null): string {
  return toLocalDateTimeInput(iso).slice(11, 16);
}

/** Combine une date et une heure locales en ISO 8601 (UTC). */
export function fromLocalInputs(date: string, timeOfDay: string): string | null {
  if (!date || !timeOfDay) return null;
  const parsed = new Date(`${date}T${timeOfDay}`);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}

export function fromLocalDateTimeInput(value: string): string | null {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}
